import i18n from '../i18n'
import { ActivityModifier, PayBy, PayOn, CostType, TemplateAccountingCategory, TemplateSpecialization, ProductionCostType } from '@/utils/Enumerations'
import { formatMoney } from '@/utils/NumericMutations'

const sortByEnumLabel = enumType => (left, right) => enumType.fromInt(left).localeCompare(enumType.fromInt(right))

export default {
  activityNoCRUDHeaders () {
    return ([
      {
        sortable: false,
        text: '',
        value: 'status',
        align: 'center'
      },
      {
        sortable: true,
        text: i18n.t('name'),
        value: 'activityTemplate.name',
        align: 'left'
      },
      {
        sortable: true,
        text: i18n.t('counterparty'),
        value: 'contractor.name'
      },
      {
        sortable: true,
        text: i18n.t('entity'),
        value: 'businessEntityName'
      },
      {
        sortable: true,
        text: i18n.t('glCode'),
        value: 'activityTemplate.glCode'
      },
      {
        sortable: true,
        text: i18n.t('glCodeOffset'),
        value: 'activityTemplate.glOffset'
      },
      {
        sortable: true,
        text: i18n.t('baseRate'),
        value: 'baseCost.rate',
        align: 'right'
      },
      {
        sortable: true,
        text: i18n.t('payOn'),
        value: 'baseCost.payOn',
        sort: sortByEnumLabel(PayOn)
      },
      {
        sortable: true,
        text: i18n.t('payBy'),
        value: 'baseCost.payBy',
        sort: sortByEnumLabel(PayBy)
      },
      {
        sortable: false,
        text: i18n.t('details'),
        value: 'details'
      },
      {
        sortable: false,
        text: '',
        value: 'data-table-expand'
      }
    ])
  },
  activityCRUDHeaders () {
    return [
      {
        sortable: false,
        text: '',
        value: 'status',
        align: 'center'
      },
      {
        sortable: true,
        text: i18n.t('name'),
        value: 'activityTemplate.name',
        align: 'left'
      },
      {
        sortable: true,
        text: i18n.t('counterparty'),
        value: 'contractor.name'
      },
      {
        sortable: true,
        text: i18n.t('entity'),
        value: 'businessEntityName'
      },
      {
        sortable: true,
        text: i18n.t('glCode'),
        value: 'activityTemplate.glCode'
      },
      {
        sortable: true,
        text: i18n.t('glCodeOffset'),
        value: 'activityTemplate.glOffset'
      },
      {
        sortable: true,
        text: i18n.t('baseRate'),
        value: 'baseCost.rate',
        align: 'right'
      },
      {
        sortable: true,
        text: i18n.t('payOn'),
        value: 'baseCost.payOn',
        sort: sortByEnumLabel(PayOn)
      },
      {
        sortable: true,
        text: i18n.t('payBy'),
        value: 'baseCost.payBy',
        sort: sortByEnumLabel(PayBy)
      },
      {
        sortable: false,
        text: i18n.t('actions'),
        value: 'actions',
        align: 'center'
      },
      {
        sortable: false,
        text: '',
        value: 'data-table-expand'
      }
    ]
  },
  activityTemplateHeaders () {
    return [
      {
        sortable: true,
        text: i18n.t('status'),
        value: 'activityStatus',
        align: 'center'
      },
      {
        sortable: true,
        text: i18n.t('name'),
        value: 'name',
        align: 'left'
      },
      {
        sortable: true,
        text: i18n.t('entity'),
        value: 'businessEntityName'
      },
      {
        sortable: true,
        text: i18n.t('type'),
        format: i => CostType.fromInt(i),
        value: 'costType'
      },
      {
        sortable: true,
        text: i18n.t('glCode'),
        value: 'glCode'
      },
      {
        sortable: true,
        text: i18n.t('glCodeOffset'),
        value: 'glOffset'
      },
      {
        sortable: true,
        text: i18n.t('baseRate'),
        value: 'baseCost.rate',
        format: formatMoney,
        align: 'right'
      },
      {
        sortable: true,
        text: i18n.t('payOn'),
        value: 'baseCost.payOn',
        format: i => PayOn.fromInt(i),
        sort: sortByEnumLabel(PayOn)
      },
      {
        sortable: true,
        text: i18n.t('payBy'),
        value: 'baseCost.payBy',
        format: PayBy.fromInt,
        sort: sortByEnumLabel(PayBy)
      },
      {
        sortable: true,
        text: i18n.t('modifier'),
        value: 'modifier',
        format: i => ActivityModifier.fromInt(i),
        align: 'center'
      },
      {
        sortable: false,
        text: i18n.t('related'),
        value: 'related',
        align: 'center'
      },
      {
        sortable: false,
        text: i18n.t('actions'),
        value: 'actions',
        align: 'center'
      }
    ]
  },

  templateBundleHeaders () {
    return [
      {
        sortable: true,
        text: i18n.t('status'),
        value: 'activityStatus',
        align: 'center'
      },
      {
        sortable: true,
        text: i18n.t('name'),
        value: 'activityTemplateName',
        align: 'left'
      },
      {
        sortable: true,
        text: i18n.t('counterparty'),
        value: 'counterpartyName'
      },
      {
        sortable: true,
        text: i18n.t('entity'),
        value: 'businessEntity'
      },
      {
        sortable: true,
        text: i18n.t('category'),
        value: 'category'
      },
      {
        sortable: true,
        text: i18n.t('type'),
        value: 'costBehavior'
      },
      {
        sortable: true,
        text: i18n.t('glCode'),
        value: 'glCode'
      },
      {
        sortable: true,
        text: i18n.t('glCodeOffset'),
        value: 'glOffset'
      },
      {
        sortable: true,
        text: i18n.t('baseRate'),
        value: 'baseRate',
        align: 'right'
      },
      {
        sortable: true,
        text: i18n.t('payOn'),
        value: 'payOn',
        sort: sortByEnumLabel(PayOn)
      },
      {
        sortable: true,
        text: i18n.t('payBy'),
        value: 'payBy',
        sort: sortByEnumLabel(PayBy)
      },
      {
        sortable: true,
        text: i18n.t('modifier'),
        value: 'modifier',
        align: 'center'
      },
      {
        sortable: false,
        text: i18n.t('actions'),
        value: 'actions',
        align: 'center'
      }
    ]
  },

  detailHeaders () {
    return [
      {
        sortable: true,
        text: i18n.t('product'),
        value: 'product'
      },
      {
        sortable: true,
        text: i18n.t('rate'),
        value: 'rate',
        align: 'right'
      },
      {
        text: i18n.t('actions'),
        value: 'actions',
        align: 'center'
      }
    ]
  },

  activityTemplateBulkImportPreviewHeaders () {
    return [
      {
        sortable: true,
        text: i18n.t('name'),
        value: 'name'
      },
      {
        sortable: true,
        text: i18n.t('status'),
        value: 'activityStatus',
        align: 'center'
      },
      {
        sortable: true,
        text: i18n.t('entity'),
        value: 'businessEntityName'
      },
      {
        sortable: true,
        text: i18n.t('category'),
        value: 'category',
        format: i => TemplateAccountingCategory.fromInt(i)
      },
      {
        sortable: true,
        text: i18n.t('type'),
        value: 'costType',
        format: i => CostType.fromInt(i)
      },
      {
        sortable: true,
        text: i18n.t('productionType'),
        format: i => ProductionCostType.fromInt(i),
        value: 'productionType'
      },
      {
        sortable: true,
        text: i18n.t('glCode'),
        value: 'glCode'
      },
      {
        sortable: true,
        text: i18n.t('glCodeOffset'),
        value: 'glOffset'
      },
      {
        sortable: true,
        text: i18n.t('baseRate'),
        value: 'rate',
        align: 'right'
      },
      {
        sortable: true,
        text: i18n.t('payOn'),
        value: 'payOn',
        format: i => PayOn.fromInt(i),
        sort: sortByEnumLabel(PayOn)
      },
      {
        sortable: true,
        text: i18n.t('payBy'),
        value: 'payBy',
        format: i => PayBy.fromInt(i),
        sort: sortByEnumLabel(PayBy)
      },
      {
        sortable: true,
        text: i18n.t('modifier'),
        value: 'modifier',
        align: 'center',
        format: i => ActivityModifier.fromInt(i)
      },
      {
        sortable: true,
        text: i18n.t('templateSpecialization'),
        value: 'specialization',
        format: i => TemplateSpecialization.fromInt(i)
      }
    ]
  },

  contractActivityTableFormHeaders () {
    return [
      {
        sortable: false,
        text: i18n.t('status'),
        value: 'activityStatus',
        align: 'center'
      },
      {
        sortable: false,
        text: i18n.t('name'),
        value: 'activityTemplateName',
        align: 'left'
      },
      {
        sortable: false,
        text: i18n.t('counterparty'),
        value: 'counterpartyName'
      },
      {
        sortable: false,
        text: i18n.t('entity'),
        value: 'businessEntityName'
      },
      {
        sortable: false,
        text: i18n.t('recoveryAbbr'),
        value: 'recoveryMode',
        tooltip: i18n.t('recoveryMode'),
        align: 'center'
      },
      {
        sortable: false,
        text: i18n.t('baseRate'),
        value: 'baseRate',
        align: 'right'
      },
      {
        sortable: false,
        text: i18n.t('rateSheet'),
        value: 'rateSheetName'
      },
      {
        sortable: false,
        text: i18n.t('payOn'),
        value: 'payOn',
        align: 'center'
      },
      {
        sortable: false,
        text: i18n.t('payBy'),
        value: 'payBy',
        align: 'center'
      },
      {
        sortable: false,
        text: i18n.t('modifier'),
        value: 'modifier',
        align: 'center'
      },
      {
        sortable: false,
        text: i18n.t('actions'),
        value: 'actions',
        align: 'center'
      }
    ]
  }
}
